import { gql } from "@/__generated__/gql";

export const ORG_ACTIONS_READY = gql(`
  query OrgActionsReady(
      $orgId: ID!
      $date: Date!
  ) {
    node(id: $orgId) {
      ... on Organization {
        id
        __typename
        rise {
          isActionGenerationComplete(date: $date)
        }
      }
    }
  }
`);
